/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendCommunication/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Email from './Email/index'
import EmailTemplate from './EmailTemplate/index'
import EmailTemplateEditor from './EmailTemplateEditor/index'
import React from 'react'
import SMS from './SMS/index'
import SMSTemplate from './SMSTemplate/index'
import SMSTemplateEditor from './SMSTemplateEditor/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SendCommunication({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="SendCommunication.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZlfYvz': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-2-ZlfYvz': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Send via"
/>
<div
  data-testid="SendCommunication.Horizontal:1"
  data-view-path={viewPath}
 style={{'--ml-3-ZlfYvz': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-4-ZlfYvz': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Email
  viewPath={`${viewPath}/Email`}
/>
<SMS
  viewPath={`${viewPath}/SMS`}
/>
</div>
</div>
<div
  data-testid="SendCommunication.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-4-ZlfYvz': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<EmailTemplate
  viewPath={`${viewPath}/EmailTemplate`}
/>
<EmailTemplateEditor
  viewPath={`${viewPath}/EmailTemplateEditor`}
/>
<SMSTemplate
  viewPath={`${viewPath}/SMSTemplate`}
/>
<SMSTemplateEditor
  viewPath={`${viewPath}/SMSTemplateEditor`}
/>
</div>
{children}
</React.Fragment>)
}